export default __webpack_public_path__ + "static/media/1949.36beba53.png";